<script setup>
import { useI18n } from 'vue-i18n';

defineProps({
  modelValue: {
    type: String,
    default: 'monthly',
  },
  discountPercentage: {
    type: Number,
    default: 0,
  },
});

const emit = defineEmits(['update:modelValue']);

const { t } = useI18n();

const handleChange = value => {
  emit('update:modelValue', value);
};
</script>

<template>
  <div class="inline-flex items-center gap-2 p-1 bg-n-alpha-1 rounded-lg">
    <button
      type="button"
      class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-200"
      :class="[
        modelValue === 'monthly'
          ? 'bg-n-solid-1 text-n-slate-12 shadow-sm'
          : 'text-n-slate-11 hover:text-n-slate-12',
      ]"
      @click="handleChange('monthly')"
    >
      {{ t('BILLING.CYCLE.MONTHLY') }}
    </button>
    <button
      type="button"
      class="px-4 py-2 text-sm font-medium rounded-md transition-all duration-200 flex items-center gap-2"
      :class="[
        modelValue === 'yearly'
          ? 'bg-n-solid-1 text-n-slate-12 shadow-sm'
          : 'text-n-slate-11 hover:text-n-slate-12',
      ]"
      @click="handleChange('yearly')"
    >
      {{ t('BILLING.CYCLE.YEARLY') }}
      <span
        v-if="discountPercentage > 0"
        class="text-xs font-semibold text-n-teal-11 bg-n-teal-3 px-2 py-0.5 rounded"
      >
        -{{ discountPercentage }}%
      </span>
    </button>
  </div>
</template>
